export const auth = {
  MINUTES_UNTIL_REAUTHETICATION: 30,
};
